import { Component, OnInit } from '@angular/core';
import { Modelo } from '../modelo.model';
import { ModeloService } from '../modelo.service';
import { Frm } from '../../components/frm/frm.interface';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { Location } from '@angular/common';

@Component({
  selector: 'app-modelo-frm',
  templateUrl: './modelo-frm.component.html',
  styleUrls: ['./modelo-frm.component.css'],
})
export class ModeloFrmComponent implements OnInit, Frm<Modelo, number> {
  public entidade: Modelo;
  public isInsercao: boolean;

  constructor(
    private service: ModeloService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.entidade = {} as Modelo;
    this.isInsercao = true;
  }

  salvar(): void {
    this.progressoService.modal();
    this.service
      .salvar(this.entidade, this.isInsercao)
      .then((modelo) => {
        this.entidade = modelo;
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'Os dados do modelo foram salvos com sucesso');
        if (this.isInsercao) {
          this.location.go(`/modelo/edicao/${this.entidade.id}`);
        }
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao salvar os dados do modelo', resposta.error);
        this.progressoService.fechar();
      });
  }

  iniciarInsercao(): void {
    this.isInsercao = true;
  }

  iniciarAlteracao(entidade: Modelo): void {
    this.isInsercao = false;
    this.entidade = entidade;
  }

  iniciarAlteracaoPorId(id: number): void {
    this.progressoService.modal();
    this.service
      .recuperarPorId(id)
      .then((modelo) => {
        this.progressoService.fechar();
        this.iniciarAlteracao(modelo);
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao recuperar o modelo para edição.', resposta.error);
      });
  }
}
